import http from '@/services/api';

const RESOURCE_NAME = 'api/settings';

export default {
  getAll() {
    return http.get(`${RESOURCE_NAME}/all`);
  },

  get(id) {
    return http.get(`${RESOURCE_NAME}/${id}`);
  },

  create(id, data = null) {
    return http.post(`${RESOURCE_NAME}/${id}`, data);
  },

  update(id, data = null) {
    return http.put(`${RESOURCE_NAME}/${id}`, data);
  },

  delete(id) {
    return http.delete(`${RESOURCE_NAME}/${id}`);
  }
};
